<!-- TODO -->
<!-- Entra sempre per via dello switch prima. Da vedere.  -->
<ng-container *ngIf="block.items.length > 1">
    <owl-carousel-o #carousel [options]="customOptionsOwl" class="position-relative container-sample-carousel no-print" (initialized)="getData($event)"
        [id]="block.bundle + '_carousel'" (translated)="getPassedData($event)">
        <ng-container *ngFor="let item of block.items; let idx = index">
            <ng-template carouselSlide let-owlItem class="d-flex justify-content-center col-12" style="gap: 20px;"
                id="{{idx+1}}">
                <ng-container [ngSwitch]="block.bundle">
                    <app-sample-media-image *ngSwitchCase="'blocco_immagine'" [block]="item"
                        [column]="block.colonne_occupate" [isCarousel]="true"></app-sample-media-image>
                    <app-sample-media-video *ngSwitchCase="'blocco_video'" [block]="item"
                        [column]="block.colonne_occupate"></app-sample-media-video>
                    <app-card-counter [isActiveCarousel]="owlItem.isCentered" [idSlide]="owlItem.id"
                        *ngSwitchCase="'blocco_numero'" [block]="item"></app-card-counter>
                    <app-sample-testimonial *ngSwitchCase="'blocco_quote_testimonial'" [block]="item"
                        [column]="block.colonne_occupate"></app-sample-testimonial>
                    <app-sample-hero *ngSwitchCase="'blocco_visore_hero_1'" [block]="item"></app-sample-hero>
                    <app-sample-text-with-image *ngSwitchCase="'blocco_paragrafo_immagine'" [block]="item"
                        [cols]="block.colonne_occupate"></app-sample-text-with-image>
                </ng-container>
            </ng-template>
        </ng-container>
    </owl-carousel-o>
    <div class="carousel-bar-comp">
        <app-carousel-hero-bar #carouselBar *ngIf="block.items && block.bundle === 'blocco_visore_hero_1' && !block.nascondi_anteprima" [carouselItems]="block.items" [id]="slideId" (changeSlideEmitter)="selectSlide($event)"></app-carousel-hero-bar>
    </div>
</ng-container>

<div class="container-print">
    <ng-container *ngFor="let item of block.items; let idx = index">
        <ng-container [ngSwitch]="block.bundle">
            <app-sample-media-image *ngSwitchCase="'blocco_immagine'" [block]="item" [column]="block.colonne_occupate"
                [isCarousel]="true"></app-sample-media-image>
            <app-sample-media-video *ngSwitchCase="'blocco_video'" [block]="item"
                [column]="block.colonne_occupate"></app-sample-media-video>
            <app-card-counter *ngSwitchCase="'blocco_numero'" [block]="item"></app-card-counter>
            <app-sample-testimonial *ngSwitchCase="'blocco_quote_testimonial'" [block]="item"
                [column]="block.colonne_occupate"></app-sample-testimonial>
            <app-sample-text-with-image *ngSwitchCase="'blocco_paragrafo_immagine'" [block]="item"
                [cols]="block.colonne_occupate"></app-sample-text-with-image>
        </ng-container>
    </ng-container>
</div>